import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/home/service.png'


import ContactServicePopup from '@/view/profile/contactServicePopup.vue';
import { ref } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'contactService',
  setup(__props) {

const contactRef = ref()

const openContactPopup = () => {
    contactRef.value.open()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { class: "container" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        onClick: openContactPopup
      })
    ]),
    _createVNode(ContactServicePopup, {
      ref_key: "contactRef",
      ref: contactRef
    }, null, 512)
  ], 64))
}
}

})